// removed by extract-text-webpack-plugin
module.exports = {"categorycontainer":"src-templates----category-module---categorycontainer---1m0k1","summary":"src-templates----category-module---summary---3PdH6"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/category.module.scss
// module id = 438
// module chunks = 129745722219136